import { render, staticRenderFns } from "./ActionBox.vue?vue&type=template&id=15c1aa6e&scoped=true&"
import script from "./ActionBox.vue?vue&type=script&lang=js&"
export * from "./ActionBox.vue?vue&type=script&lang=js&"
import style0 from "./ActionBox.vue?vue&type=style&index=0&id=15c1aa6e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15c1aa6e",
  null
  
)

export default component.exports